import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Modal } from '../../../../components/Modal';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { fetchInvoice } from '../../../Invoices/actions';
import { selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../constants';
import { GeneratePdfButton } from '../../../../components/GeneratePdfButton/GeneratePdfButton';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { selectAllOptions } from '../../selectors';


import { REQUEST_INVOICE } from '../../../Invoices/constants';
import { Loader } from '../../../../components/Loader';
import { selectAddressTypes } from '../../../Address/selectors';
import { Flag } from '../../../../containers/App/LanguageSelection';
import { CompanyLabel } from '../../../Companies/components/CompanyLabel';
import { fetchCompany } from '../../../Companies/actions';
import { ChangeLocationModal } from '../ChangeLocationModal';
import { Checkbox } from '../../../../components/Checkbox';
import { CompanySaleAgreement } from './CompanySalesAgreement';
import { ExportSaleAgreement as component1 } from "./1/ExportSalesAgreement";
import { ExportSaleAgreement as component2 } from "./2/ExportSalesAgreement";
import { ExportSaleAgreement as component3 } from "./3/ExportSalesAgreement";
import { ExportSaleAgreement as component4 } from "./4/ExportSalesAgreement";
import { ExportSaleAgreement as component6 } from "./6/ExportSalesAgreement";
import { ExportSaleAgreement as component7 } from "./7/ExportSalesAgreement";
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';

let ExportSaleAgreement = component7;

switch (env.clientId) {
  case AppClientId.INDEWAL: ExportSaleAgreement = component1;
    break;
    case AppClientId.IDWLEASE: ExportSaleAgreement = component1;
    break;
  case AppClientId.HARRY_NIJBOER: ExportSaleAgreement = component2;
    break;
  case AppClientId.HOOIKAMMER: ExportSaleAgreement = component3;
    break;
  case AppClientId.IDW_GMBH: ExportSaleAgreement = component4;
    break;
  case AppClientId.AUTOWIENTJES: ExportSaleAgreement = component6;
    break;
  case AppClientId.AUTOHUISSALLAND: ExportSaleAgreement = component7;

    break;
}



const Container = styled.div`
  font-size: 14px;
  margin: 10px auto;
  margin-bottom: 50px;

  width: 1240px;
  height: ${props => (props.pageQuantity ? `${1754 * props.pageQuantity}px` : '1754px')};
  background-color: white;
  color: black;
`;

const Selection = styled.div`
  display: flex;
  cursor: pointer;

  img {
    width: 50px;
    height: 50px;
  }
  .flag {
    text-align: center;
    margin: 12px;
    border-radius: 40px;
    overflow: hidden;
    width: 60px;
    height: 60px;
  }

  .lang-label {
    font-size: 18px;
    color: black;
  }
`;

const Address = styled.div`
  border: 1px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

const COMPANY_MANUAL_FIELDS = [
  'company_name',
  'addressLine1',
  'postcode',
  'city',
  'country',
  'company_email',
  'relation_number',
];
const INDIVIDUAL_MANUAL_FIELDS = [
  'company_name',
  'surname',
  'company_email',
  'addressLine1',
  'postcode',
  'city',
  'phone_number',
  'relation_number',
];
const EXPORT_MANUAL_FIELDS = [
  'company_name',
  'addressLine1',
  'postcode',
  'city',
  'country',
  'company_email',
  'BTW_number',
  'relation_number',
];

const STATE = {
  selectedLanguage: null,
  selectedAgreementType: '',
  outgoingCompanyId: null,
  manualAddress: {
    individual: false,
    company_name: '',
    addressLine1: '',
    postcode: '',
    city: '',
    country: { name: '' },
  },
};

/* eslint-disable react/prefer-stateless-function */
class SaleAgreementPdfPreviewComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchInvoice(result => {
      if (result?.outgoingCompanyId) {
        this.setState({ outgoingCompanyId: result.outgoingCompanyId });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.outgoingCompanyId != this.state.outgoingCompanyId ||
      (this.state.outgoingCompanyId && !this.state.company?.id && !this.state.address?.company_name)
    ) {
      this.props.fetchCompany(this.state.outgoingCompanyId, result => {
        if (result?.id) {
          this.setState({
            company: result,
            address: result?.addresses?.find(address => address?.type?.id == this.homeAddressId),
          });
        }
      });
    }
  }

  get homeAddressId() {
    const homeId = this.props.addressTypes.filter(t => t.name === 'home')[0].id;
    return homeId;
  }

  get pageQuantity() {
    const quantity = this.state.selectedAgreementType == 'export' ? 2 : 1;
    return quantity;
  }

  get renderGenerateButton() {
    if (this.state.selectedAgreementType == 'export') return true;
    return this.state.selectedLanguage;
  }

  get isExport() {
    return this.state.selectedAgreementType == 'export';
  }

  getFieldsByAgreementType() {
    let fields = [];
    switch (this.state.selectedAgreementType) {
      case 'company':
        return COMPANY_MANUAL_FIELDS;
      case 'individual':
        return INDIVIDUAL_MANUAL_FIELDS;
      case 'export':
        return EXPORT_MANUAL_FIELDS;
    }
    return fields;
  }

  renderCompanySalesAgreement() {
    return this.state.selectedLanguage && this.state.selectedAgreementType == 'company';
  }

  renderIndividualSalesAgreement() {
    return this.state.selectedLanguage && this.state.selectedAgreementType == 'individual';
  }

  renderExportSalesAgreement() {
    return this.state.selectedAgreementType == 'export';
  }

  onAgreementTypeChange(type) {
    return this.setState({ selectedAgreementType: type });
  }

  onSetLocation = (company, address) => {
    this.setState({
      company,
      address,
      showLocationChange: false,
      setLocationManual: false,
    });
  };

  onManualInputChange(e) {
    e.persist();

    if (e.target.name == 'country') {
      return this.setState(prev => {
        return {
          manualAddress: {
            ...prev.manualAddress,
            country: {
              name: e.target?.value,
            },
          },
        };
      });
    }
    this.setState(prev => {
      return {
        manualAddress: { ...prev.manualAddress, [e.target?.name]: e.target?.value },
      };
    });
  }

  renderAddress = () => {
    const company = this.state.company;
    const address = this.state.address || this.props.address;

    //if (!company?.id && !address?.company_name) return <Loader small />;

    if (!address || this.state.selectedAgreementType) {
      return (
        <VBox style={{ width: '30%' }}>
          {' '}
          <HBox left>

          {this.state.selectedAgreementType && 
            <Button small onClick={this.setStateFn({ setLocationManual: true })}>
              {this.lbl('vehicle.location.manual')}
            </Button>
            }
            {this.state.selectedAgreementType && 
          
            <Button small disabled={this.state.setLocationManual} onClick={this.setStateFn({ showLocationChange: true })}>
              {this.lbl('vehicle.location.change_relation')}
            </Button>
            }
          </HBox>
        </VBox>
      );
   
    }

    return (
      <VBox style={{ width: '30%' }}>
        <HBox left>

          {this.state.selectedAgreementType &&
            <Button small onClick={this.setStateFn({ setLocationManual: true })}>
              {this.lbl('vehicle.location.manual')}
            </Button>
            }
            {this.state.selectedAgreementType && 
          
            <Button small disabled={this.state.setLocationManual} onClick={this.setStateFn({ showLocationChange: true })}>
              {this.lbl('vehicle.location.change_relation')}
            </Button>
            }
        </HBox>
        <Address key={`${address?.id}`}>
          {company ? (
            <span className="name" style={{ textTransform: 'uppercase', fontWeight: 600 }}>
              <CompanyLabel company={company} />
            </span>
          ) : null}
          {address?.company_name && (
            <span className="name" style={{ textTransform: 'uppercase', fontWeight: 600 }}>
              <span className="company-label">{address?.company_name}</span>
            </span>
          )}
          <HBox vCenter left>
            {this.lbl(`address.type.${address?.type?.name || 'other'}`)}
            &nbsp;
          </HBox>
          <VBox left>
            <div>{address?.addressLine1}</div>
            <div>
              {address?.postcode} {address?.city}
            </div>
            <div>{address.country?.name}</div>
          </VBox>
        </Address>
      </VBox>
    );
  };

  render() {
    const vehicle = this.props.vehicle;
    if (this.props.work)
      return (
        <Modal>
          <HBox center>
            <Loader />
          </HBox>
        </Modal>
      );
    return (
      <Modal pdfView onClose={this.props.onClose}>
        <VBox>
          <strong>{this.lbl('vehicle.details.pickup_statement.select_language')}</strong>
          <HBox left vCenter >
            <Selection>
              {['nl', 'de', 'en', 'pl'].map(locale => (
                <Flag
                  className="flag"
                  style={{
                    border: this.state.selectedLanguage == locale ? '5px solid forestgreen' : 'none',
                    cursor: this.isExport ? 'not-allowed' : 'pointer',
                  }}
                  key={locale}
                  onClick={this.setStateFn({ selectedLanguage: locale })}
                  src={`/public/images/${locale}.svg`}
                />
              ))}
            </Selection>
          </HBox>
          {this.state.selectedLanguage &&
        <> 
          <strong>{this.lbl('vehicle.details.sale_agreement.select_sales_agreement')}</strong>
          <HBox left vCenter style={{ width: '30%' }}>
            <Checkbox
              checked={this.state.selectedAgreementType == 'individual'}
              onChange={() => this.onAgreementTypeChange('individual')}
            >
              {this.lbl(`vehicle.details.sale_agreement.individual`)}
            </Checkbox>
            <Checkbox
              checked={this.state.selectedAgreementType == 'company'}
              onChange={() => this.onAgreementTypeChange('company')}
            >
              {' '}
              {this.lbl(`vehicle.details.sale_agreement.company`)}
            </Checkbox>
            <Checkbox
              checked={this.state.selectedAgreementType == 'export'}
              onChange={() => this.onAgreementTypeChange('export')}
            >
              {' '}
              {this.lbl(`vehicle.details.sale_agreement.export`)}
            </Checkbox>


          </HBox>
          </>   
  }
       
          {this.renderAddress()}
          {this.state.setLocationManual && (
            <Modal>
              <VBox gap={6}>
                {this.getFieldsByAgreementType()?.map(type => {
                  if (type == 'country') {
                    return (
                      <FormField key={type}>
                        <Input
                          full
                          name={type}
                          placeholder={type}
                          value={this.state.manualAddress?.country?.name}
                          onChange={this.onManualInputChange.bind(this)}
                        />
                      </FormField>
                    );
                  }
                  return (
                    <FormField key={type}>
                      <Input
                        full
                        name={type}
                        placeholder={type}
                        value={this.state.manualAddress?.[type]}
                        onChange={this.onManualInputChange.bind(this)}
                      />
                    </FormField>
                  );
                })}
                <HBox left>
                  <Button primary small onClick={() => this.onSetLocation({}, this.state.manualAddress)}>
                    {this.lbl('save')}
                  </Button>
                  <Button warning small onClick={this.setStateFn({ setLocationManual: false })}>
                    {this.lbl('cancel')}
                  </Button>
                </HBox>
              </VBox>
            </Modal>
          )}
        </VBox>

        <Container pageQuantity={this.pageQuantity}>
          {this.state.showLocationChange && (
            <ChangeLocationModal
              company={vehicle?.locationCompany}
              address={vehicle?.locationAddress}
              onClose={() => this.setState({ showLocationChange: false })}
              onConfirm={this.onSetLocation}
            />
          )}
          {this.renderCompanySalesAgreement() && (
            <VBox id={'Sales_agreement'} style={{ height: '97%' }}>
              <CompanySaleAgreement
                agreementType={this.state.selectedAgreementType}
                vehicle={vehicle}
                outgoingInvoiceId={vehicle?.outgoing_invoice}
                language={this.state.selectedLanguage}
                company={this.state.company}
                address={this.state.address}
              />
            </VBox>
          )}
          {this.renderIndividualSalesAgreement() && (
            <VBox id={'Sales_agreement'} style={{ height: '97%' }}>
              <CompanySaleAgreement
                agreementType={this.state.selectedAgreementType}
                vehicle={vehicle}
                outgoingInvoiceId={vehicle?.outgoing_invoice}
                language={this.state.selectedLanguage}
                company={this.state.company}
                address={this.state.address}
              />
            </VBox>
          )}
          {this.renderExportSalesAgreement() && (
            <VBox id={'Sales_agreement'} style={{ height: '97%' }}>
              <ExportSaleAgreement
                vehicle={vehicle}
                outgoingInvoiceId={vehicle?.outgoing_invoice}
                pageQuantity={this.pageQuantity}
                language={this.state.selectedLanguage}
                company={this.state.company}
                address={this.state.address}
              />
            </VBox>
          )}
        </Container>
        {this.renderGenerateButton && (
          <GeneratePdfButton sectionId={'Sales_agreement'} label={'PDF'} widthMn={210} heightMm={297} />
        )}
      </Modal>
    );
  }
}

SaleAgreementPdfPreviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loadingChecks: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    work: selectWorks([REQUEST_INVOICE]),
    allOptions: selectAllOptions(),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps?.vehicle?.outgoing_invoice, callback));
    },
    fetchCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SaleAgreementPdfPreview = compose(withConnect, withRouter)(SaleAgreementPdfPreviewComp);
